import React, { Component } from "react";
import { Row, Label } from "reactstrap";
import { withNamespaces } from "react-i18next";
import DataTable from "../../../Components/DataTable";
import { config } from "./config";
import { MODULES } from "../../../../Middlewares/menuConfig";
class QuickResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      activePageShipment: 0,
      totalPagesShipment: 0,
      activePagePedido: 0,
      totalPagesPedido: 0,
      activePageTransportPlan: 0,
      totalPagesTransportPlan: 0,
      activePageContainer: 0,
      totalPagesContainer: 0,
      totalContainer: 0,
      totalPedido: 0,
      totalShipment: 0,
      totalTransportPlan: 0,
      totalPOs: 0,
      activePagePOs: 0,
      totalPagesPOs: 0,
      config: config,
      dataPage: {
        Shipments: { Shipments: [] },
        Containers: { Containers: [] },
        Pedidos: { Pedidos: [] },
        TransportPlan: { TransportPlan: [] },
        POs: { POs: [] },
      },
      modules: props.modules
    };
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.data)
      this.setState(
        {
          data: nextProps.data,
          dataPage: nextProps.data,
          allData: nextProps.data,
        },
        () => {
          this.initPages();
        }
      );
  };

  initPages = () => {
    const { dataPage } = this.state;

    let pagShipment = Math.ceil(parseInt(dataPage.Shipments.Total) / 10);
    let totalShipment = dataPage.Shipments.Total;

    let pagContainer = Math.ceil(parseInt(dataPage.Containers.Total) / 10);
    let totalContainer = dataPage.Containers.Total;

    let pagTransportPlan = Math.ceil(
      parseInt(dataPage.TransportPlan.Total) / 10
    );
    let totalTransportPlan = dataPage.TransportPlan.Total;

    let pagPedido = Math.ceil(parseInt(dataPage.Pedidos.Total) / 10);
    let totalPedido = dataPage.Pedidos.Total;

    let pagPOs = Math.ceil(parseInt(dataPage.POs.Total) / 10);
    let totalPOs = dataPage.POs.Total;

    this.setState({
      activePageShipment: 1,
      totalPagesShipment: pagShipment,
      totalShipment,

      activePageContainer: 1,
      totalPagesContainer: pagContainer,
      totalContainer,

      activePageTransportPlan: 1,
      totalPagesTransportPlan: pagTransportPlan,
      totalTransportPlan,

      activePagePedido: 1,
      totalPagesPedido: pagPedido,
      totalPedido,

      activePagePOs: 1,
      totalPagesPOs: pagPOs,
      totalPOs,
    });
  };

  setResultsByPage = (page, all) => {
    page = page - 1;
    const pag = all.slice(page * 10, (page + 1) * 10);
    return pag;
  };

  changePage = (page, from) => {
    switch (from) {
      case "pedidos":
        this.setState({
          activePagePedido: page,
        });
        break;
      case "planes":
        this.setState({
          activePageTransportPlan: page,
        });
        break;
      case "contenedores":
        this.setState({
          activePageContainer: page,
        });
        break;
      case "embarques":
        this.setState({
          activePageShipment: page,
        });
        break;
      case "pos":
        this.setState({
          activePagePOs: page,
        });
      default:
        break;
    }
    // this.buildPageResults(from)
  };

  render() {
    let {
      activePageShipment,
      totalShipment,
      activePageTransportPlan,
      totalTransportPlan,
      activePageContainer,
      totalContainer,
      activePagePedido,
      totalPedido,
      activePagePOs,
      totalPOs,
      modules
    } = this.state;
    return (
      <div>
        {
          modules[MODULES.po_visibility.id] && (
            <Row>
              <div className="col-12">
                <div className="col-12">
                  <br />
                  <h4>{this.props.t("requests")}</h4>
                  <Label>
                    {activePagePedido * 10 > totalPedido
                      ? totalPedido
                      : activePagePedido * 10}{" "}
                    {this.props.t("of")} {totalPedido} {this.props.t("results")}
                  </Label>
                </div>
              </div>
              <div className="col-12">
                {totalPedido !== 0 ? (
                  <DataTable
                    showSearch={false}
                    showExcel={false}
                    labelSelected=""
                    data={this.state.dataPage.Pedidos.Pedidos}
                    columnsTable={this.state.config.pedido}
                    activePage={this.state.activePagePedido}
                    pages={this.state.totalPagesPedido}
                    maxPerPage={10}
                  ></DataTable>
                ) : (
                  ""
                )}
              </div>
            </Row>
          )
        }
        {
          modules[MODULES.po_management.id] && (
            <Row>
              <div className="col-12">
                <div className="col-12">
                  <br />
                  <h4>{this.props.t("purchase_order")}</h4>
                  <Label>
                    {activePagePOs * 10 > totalPOs
                      ? totalPOs
                      : activePagePOs * 10}{" "}
                    {this.props.t("of")} {totalPOs} {this.props.t("results")}
                  </Label>
                </div>
              </div>
              <div className="col-12">
                {totalPOs !== 0 ? (
                  <DataTable
                    showSearch={false}
                    showExcel={false}
                    labelSelected=""
                    data={this.state.dataPage.POs.POs}
                    columnsTable={this.state.config.pos}
                    activePage={this.state.activePagePOs}
                    pages={this.state.totalPagesPOs}
                    maxPerPage={10}
                  ></DataTable>
                ) : (
                  ""
                )}
              </div>
            </Row>
          )
        }
        {
          modules[MODULES.transport_plans.id] && (
            <Row>
              <div className="col-12">
                <div className="col-12">
                  <br />
                  <h4>{this.props.t("transports_plans")}</h4>
                  <Label>
                    {activePageTransportPlan * 10 > totalTransportPlan
                      ? totalTransportPlan
                      : activePageTransportPlan * 10}{" "}
                    {this.props.t("of")} {totalTransportPlan}{" "}
                    {this.props.t("results")}
                  </Label>
                </div>
              </div>
              <div className="col-12">
                {totalTransportPlan !== 0 ? (
                  <DataTable
                    showSearch={false}
                    showExcel={false}
                    labelSelected=""
                    data={this.state.dataPage.TransportPlan.TransportPlan}
                    columnsTable={this.state.config.transport}
                    activePage={this.state.activePageTransportPlan}
                    pages={this.state.totalPagesTransportPlan}
                    maxPerPage={10}
                  ></DataTable>
                ) : (
                  ""
                )}
              </div>
            </Row>
          )
        }
        {
          modules[MODULES.shipments_visibility.id] && (
            <Row>
              <div className="col-12">
                <div className="col-12">
                  <br />
                  <h4>{this.props.t("shipments")}</h4>
                  <Label>
                    {activePageShipment * 10 > totalShipment
                      ? totalShipment
                      : activePageShipment * 10}{" "}
                    {this.props.t("of")} {totalShipment} {this.props.t("results")}
                  </Label>
                </div>
              </div>
              <div className="col-12">
                {totalShipment !== 0 ? (
                  <DataTable
                    showSearch={false}
                    showExcel={false}
                    labelSelected=""
                    data={this.state.dataPage.Shipments.Shipments}
                    columnsTable={this.state.config.shipment}
                    activePage={this.state.activePageShipment}
                    pages={this.state.totalPagesShipment}
                    maxPerPage={10}
                  ></DataTable>
                ) : (
                  ""
                )}
              </div>
            </Row>
          )
        }
        <Row>
          <div className="col-12">
            <div className="col-12">
              <br />
              <h4>{this.props.t("containers")}</h4>
              <Label>
                {activePageContainer * 10 > totalContainer
                  ? totalContainer
                  : activePageContainer * 10}{" "}
                {this.props.t("of")} {totalContainer} {this.props.t("results")}
              </Label>
            </div>
          </div>
          <div className="col-12">
            {totalContainer !== 0 ? (
              <DataTable
                showSearch={false}
                showExcel={false}
                labelSelected=""
                data={this.state.dataPage.Containers.Containers}
                columnsTable={this.state.config.container}
                activePage={this.state.activePageContainer}
                pages={this.state.totalPagesContainer}
                maxPerPage={10}
              ></DataTable>
            ) : (
              ""
            )}
          </div>
        </Row>
      </div>
    );
  }
}
export default withNamespaces()(QuickResult);
